import React, { useState, useEffect } from "react";
import { useStore } from "store";
import { useWindowDimensions } from "resources/BrowserManager";
import {
  Typography,
  Button,
  Space,
  message,
  Flex,
  Card,
  Tag,
  Input,
  Row,
  Col,
} from "antd";
const { Title, Text } = Typography;
import {} from "@ant-design/icons";

import CONSTANTS from "shared/constants";
import strings from "resources/strings";

import CFDI from "../../CFDI/components";

import "./style.scss";
const styleWrapperClass = "adminRfcs";

export default function AdminRFCs() {
  const { isSmallView } = useWindowDimensions();

  const user = useStore((state) => state.user);
  const activeRfc = useStore((state) => state.activeRfc);
  const setActiveRfc = useStore((state) => state.setActiveRfc);

  const [isHandlingRequest, setIsHandlingRequest] = useState(false);
  const [InputValue, setInputValue] = useState(null);

  // useEffect(() => {
  //   setActiveRfc("admin-empty");
  //   return;
  // }, []);

  const onInputChange = (e) => {
    setInputValue(e.target.value.toUpperCase());
  };

  const handleOk = async () => {
    console.log("ok");
    setActiveRfc("GAAG940902FY3");
    //Call server
    // setIsHandlingRequest(true);
    // const res = await ApiManager.postUserCreditCoupon(InputValue);
    // setIsHandlingRequest(false);
    // if (res.response.code === 3003) {
    //   message.error(strings.alertCreditCouponInvalid);
    //   return;
    // } else if (res.response.code === 3004) {
    //   message.warning(strings.alertCreditCouponAlreadyApplied);
    //   return;
    // } else if (res.response.code === 3005) {
    //   message.warning(strings.alertCreditCouponClassAlreadyApplied);
    //   return;
    // } else if (res.response.code !== 2000) {
    //   message.error(strings.alertUnexpectedError);
    //   return;
    // }
    // //update user
    // const user = res.data;
    // setUser(user);
    // message.success(strings.alertCreditCouponOk, 10);
    // handleCancel();
  };

  return (
    <div className={styleWrapperClass}>
      <Title level={1}>RFCs</Title>

      <Flex vertical gap={0}>
        <Flex gap={5}>
          <Input
            addonBefore={`RFC`}
            placeholder="XAXX010101000"
            count={{ max: 13 }}
            maxLength={13}
            style={{ width: "100%", maxWidth: "400px" }}
            disabled={isHandlingRequest}
            name="rfc"
            value={InputValue}
            onInput={onInputChange}
            onPressEnter={handleOk}
          />
          <Button type="primary" disabled={!!!InputValue} onClick={handleOk}>
            Buscar
          </Button>
        </Flex>

        {activeRfc !== "admin-empty" && (
          <>
            <Title level={4}>XAXX010101000</Title>

            <Title level={5}>Usuarios</Title>
            <Card style={{ maxWidth: "500px" }}>list of linked users</Card>

            <CFDI source={"admin"} />
          </>
        )}
      </Flex>
    </div>
  );
}
